import { useToastContext } from "components/alert/ToastContext";
import BaseListagem from "components/BaseListagem";
import ReportEdit from "components/reports/ReportEdit";
import CentroCusto from "model/administracao/cadastro/centrocusto/CentroCusto";
import Usuario from "model/administracao/cadastro/Usuario";
import { FilterMatchMode, FilterOperator } from "primereact/api";
import { Button } from "primereact/button";
import { Column, ColumnFilterElementTemplateOptions } from "primereact/column";
import { DataTable, DataTableFilterMeta, DataTableStateEvent } from "primereact/datatable";
import { Dialog } from "primereact/dialog";
import { Dropdown } from "primereact/dropdown";
import { SplitButton } from "primereact/splitbutton";
import { useLoadingContext } from "provider/LoadingProvider";
import { useEffect, useState } from "react";
import { useNavigate, useSearchParams } from "react-router-dom";
import UsuarioLogadoService from "service/usuario/UsuarioLogadoService";
import ViagemService from "service/viagem/ViagemService";
import { dateRangeFilterTemplate, filterApplyTemplate, IdListMatchModeOptions, IdMatchModeOptions, ListMatchModeOptions, NumberMatchModeOptions, statusFilterTemplate, TextMatchModeOptions } from "utils/filterUtils";
import saveAs from 'file-saver';
import { converterData } from "utils/convert";
import Viagem from "model/viagem/Viagem";
import Base from "components/Base";
import Pageable from "model/page/Pageable";
import { useFilter } from "contexts/FilterContext";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { BaseModel } from "model/BaseModel";
import { confirmDialog } from "primereact/confirmdialog";
import { MultiSelect, MultiSelectChangeEvent } from "primereact/multiselect";

const viagemService = new ViagemService();
const usuarioLogadoService = new UsuarioLogadoService();

export default function MinhasViagensListagem() {

    const [queryParameters] = useSearchParams();
    const navigate = useNavigate();

    const { msgSucesso, msgErro, msgAlerta } = useToastContext();
    const { startLoading, stopLoading } = useLoadingContext();

    const [titulo, setTitulo] = useState<string>('Minhas Viagens');
    const [filtrando, setFiltrando] = useState<boolean>(false);
    const [rows, setRows] = useState<Viagem[]>([]);
    const [pageable, setPageable] = useState(new Pageable(0, 10, "id,DESC", 0));
    const [totalElements, setTotalElements] = useState<number>(0);
    const [usuariosDisponiveis, setUsuariosDisponiveis] = useState<Usuario[]>([]);
    const [centrosCustoDisponiveis, setCentrosCustoDisponiveis] = useState<CentroCusto[]>([]);
    const [visibleDialogRelatorios, setVisibleDialogRelatorios] = useState(false);
    const [editaRelatorios, setEditaRelatorios] = useState(false);
    const [excluindo, setExcluindo] = useState<boolean>(false);

    useEffect(() => {
        usuarioLogadoService.getAcoesUsuarioLogado().then((resposta) => {
            if (usuarioLogadoService.usuarioTemAlgumaAcao(resposta, ["RELATORIO_VIAGEM_LISTAGEM_EDITAR"])) {
                setEditaRelatorios(true);
            }
        }).catch((erro) => {
            console.log(erro);
        });
        viagemService.getUsuariosDisponiveis().then((response) => {
            setUsuariosDisponiveis(response)
        }).catch(err => {
            console.error(err);
        })
        viagemService.getCentroCustoDisponiveis().then((response) => {
            setCentrosCustoDisponiveis(response)
        }).catch(err => {
            console.error(err);
        });
    }, [])

    const defaultFilters: DataTableFilterMeta = {
        codigo: {
            constraints: [
                {
                    value: '',
                    matchMode: FilterMatchMode.EQUALS,
                }
            ],
            operator: FilterOperator.AND
        },
        situacao: {
            constraints: [
                {
                    value: ['1', '2', '3', '4', '5', '6'],
                    matchMode: FilterMatchMode.IN,
                }
            ],
            operator: FilterOperator.AND
        },
        usuarioSolicitante: {
            constraints: [
                {
                    value: '',
                    matchMode: FilterMatchMode.EQUALS,
                }
            ],
            operator: FilterOperator.AND
        },
        centroCusto: {
            constraints: [
                {
                    value: null,
                    matchMode: FilterMatchMode.IN,
                }
            ],
            operator: FilterOperator.AND
        },
        dataSolicitacao: {
            constraints: [
                {
                    value: '',
                    matchMode: FilterMatchMode.EQUALS,
                }
            ],
            operator: FilterOperator.AND
        },
        itinerario: {
            constraints: [
                {
                    value: '',
                    matchMode: FilterMatchMode.STARTS_WITH,
                }
            ],
            operator: FilterOperator.AND
        },
        dataPartida: {
            constraints: [
                {
                    value: '',
                    matchMode: FilterMatchMode.EQUALS,
                }
            ],
            operator: FilterOperator.AND
        },
        dataRetorno: {
            constraints: [
                {
                    value: '',
                    matchMode: FilterMatchMode.EQUALS,
                }
            ],
            operator: FilterOperator.AND
        },
        tipoLocomocao: {
            constraints: [
                {
                    value: '',
                    matchMode: FilterMatchMode.IN,
                }
            ],
            operator: FilterOperator.AND
        },
        valorAdiantamento: {
            constraints: [
                {
                    value: '',
                    matchMode: FilterMatchMode.EQUALS,
                }
            ],
            operator: FilterOperator.AND
        },
    }
    const filterContext = useFilter();
    const screen = "minhasViagens";
    const [filters, setFilters] = useState<DataTableFilterMeta>(filterContext.filters[screen] ? filterContext.filters[screen] : defaultFilters);

    const usuarioFilterTemplate = (options: ColumnFilterElementTemplateOptions) => {
        return <Dropdown value={options.value} options={usuariosDisponiveis} filter
            onChange={(e) => options.filterCallback(e.value)}
            optionLabel="nome" optionValue="id" placeholder="Qualquer" className="p-column-filter" />
    }

    const centroCustoFilterTemplate = (options: ColumnFilterElementTemplateOptions, opcoes: any[]) => {
        return <MultiSelect value={options.value} options={opcoes}
            onChange={(e: MultiSelectChangeEvent) => options.filterCallback(e.value)}
            optionLabel="nome" optionValue="id" placeholder="Qualquer" className="p-column-filter"
        />;
    };

    useEffect(() => {
        setFiltrando(true);
    }, []);

    useEffect(() => {
        setFiltrando(true);
    }, [filters]);

    useEffect(() => {
        if (filtrando) {
            filterContext.updateFilters(screen, filters);
            viagemService
                .pesquisarUsuario(pageable, filters)
                .then(lista => {
                    setFiltrando(false);
                    setRows(lista.content);
                    setTotalElements(lista.totalElements);
                })
                .catch(err => {
                    setFiltrando(false);
                });
        }
    }, [filtrando, pageable]);

    function getButtonsExtra() {
        return [
            editaRelatorios ? <SplitButton
                icon="pi pi-file-pdf"
                style={{ marginRight: 8 }}
                onClick={() => gerarRelatorioListagem()}
                model={[{
                    label: "Alterar relatórios",
                    command: () => setVisibleDialogRelatorios(true)
                }]}
            /> : <Button
                type="button"
                icon="pi pi-file-pdf"
                style={{ marginRight: 8 }}
                onClick={() => gerarRelatorioListagem()}
            />
        ]
    }

    function gerarRelatorioListagem() {
        startLoading();
        viagemService.getRelatorioListagem(filters).then(data => {
            stopLoading();
            const file = new Blob([data], { type: 'application/pdf' });
            saveAs(file, `Viagens.pdf`);
        }).catch(err => {
            stopLoading();
            msgErro("Erro ao gerar Relatório", err.message);
            console.log(err);
        });
    }

    const onPage = (event: DataTableStateEvent) => {

        setPageable({ ...pageable, page: event.page !== undefined ? event.page : 0, first: event.first });
        setFiltrando(true);

    };

    const clearFilter = () => {
        setFilters(defaultFilters || {});
    }

    function remover(id: number) {

        confirmDialog({
            acceptLabel: 'Sim',
            rejectLabel: 'Não',
            message: 'Deseja realmente excluir este registro?',
            header: 'Confirmação',
            icon: 'pi pi-exclamation-triangle',
            accept: () => removerConfirm(id),
        });


    }

    function removerConfirm(id: number) {
        setExcluindo(true);
        viagemService
            .excluir(id)
            .then(() => {
                setFiltrando(true);
                msgSucesso(titulo, 'Registro removido com sucesso!');
            })
            .catch(error => {
                console.error(error);
                if (error && error.data && error.data.message) {
                    msgErro(titulo, error.data.message);
                } else {
                    msgErro(titulo, 'Ocorreu um erro ao tentar remover o registro, tente novamente!');
                }

            }).finally(() => {
                setExcluindo(false);
            });
    }

    const header = <div style={{ display: "flex", justifyContent: "space-between", textAlign: 'center', alignContent: "center" }}>
        <div></div>
        <span style={{ textAlign: 'center', alignSelf: "center", position: 'relative' }}>{titulo}</span>

        <div >
            <Button type="button" icon="pi pi-filter-slash" label="Limpar" outlined onClick={clearFilter} style={{ marginRight: 8 }} />

            <Button
                style={{}}
                type="button" icon={<FontAwesomeIcon icon="add" />}
                className="ui-button-info"
                onClick={() => navigate(`/viagem/cadastrar`)}
            ></Button>

        </div>
    </div>

    return (
        <>
            <Dialog visible={visibleDialogRelatorios}
                onHide={() => setVisibleDialogRelatorios(false)}
                header="Relatórios"
                style={{ width: "50%" }}
            >
                <ReportEdit nomeAcao="RELATORIO_VIAGEM_LISTAGEM_EDITAR" titulo="Relatório de listagem" testarRelatorio={() => { }} style={{ marginBottom: 10 }} />
            </Dialog>
            <Base tituloPagina="Minhas Viagens">
                <DataTable
                    header={header}
                    value={rows} lazy dataKey="id" paginator
                    first={pageable.first} rows={10} totalRecords={totalElements} onPage={onPage}
                    loading={filtrando} tableStyle={{ minWidth: '75rem' }}
                    filters={filters} onFilter={(e) => setFilters(e.filters)}
                    emptyMessage="Nenhum registro encontrado"
                >
                    <Column
                        field="codigo" header="Nr."
                        filter showFilterOperator={false} showAddButton={false} filterPlaceholder="Escreva o filtro"
                        filterMatchModeOptions={NumberMatchModeOptions} filterApply={filterApplyTemplate}
                    />
                    <Column field="situacao" header="Situação" filterField="situacao"
                        filter showFilterOperator={false} showAddButton={false} filterPlaceholder="Escreva o filtro"
                        filterMatchModeOptions={ListMatchModeOptions} filterApply={filterApplyTemplate}
                        filterElement={(options) => statusFilterTemplate(options, viagemService.getSituacaoFilter())}
                        body={(rowData) => viagemService.getSituacao(rowData.situacao)}
                    />
                    <Column
                        field="usuarioSolicitante.nome" header="Solicitante" filterField="usuarioSolicitante"
                        filter showFilterOperator={false} showAddButton={false} filterPlaceholder="Escreva o filtro"
                        filterMatchModeOptions={IdMatchModeOptions} filterApply={filterApplyTemplate} filterElement={usuarioFilterTemplate}
                    />
                    <Column
                        field="centroCusto.nome" header="Centro de custo" filterField="centroCusto"
                        filter showFilterOperator={false} showAddButton={false} filterPlaceholder="Escreva o filtro"
                        filterMatchModeOptions={IdListMatchModeOptions} filterApply={filterApplyTemplate} filterElement={(options) =>centroCustoFilterTemplate(options, centrosCustoDisponiveis)}
                    />
                    <Column
                        field="itinerario" header="Itinerário"
                        filter showFilterOperator={false} showAddButton={false} filterPlaceholder="Escreva o filtro"
                        filterMatchModeOptions={TextMatchModeOptions} filterApply={filterApplyTemplate}
                    />
                    <Column field="tipoLocomocao" header="Locomoção" filterField="tipoLocomocao"
                        filter showFilterOperator={false} showAddButton={false} filterPlaceholder="Escreva o filtro"
                        filterMatchModeOptions={ListMatchModeOptions} filterApply={filterApplyTemplate}
                        filterElement={(options) => statusFilterTemplate(options, viagemService.getTipoLocomocaoFilter())}
                        body={(rowData) => viagemService.getTipoLocomocao(rowData.tipoLocomocao)}
                    />
                    <Column field="dataSolicitacao" header="Dt. Solicitação" body={(rowData: Viagem) => converterData(rowData.dataSolicitacao)}
                        filter showFilterOperator={false} showAddButton={false} filterPlaceholder="Escreva o filtro" filterField="dataSolicitacao"
                        filterElement={dateRangeFilterTemplate} showFilterMenuOptions={false} filterApply={filterApplyTemplate} filterMenuStyle={{ zIndex: 50 }}
                    />
                    <Column field="dataPartida" header="Dt. Partida" body={(rowData: Viagem) => converterData(rowData.dataPartida)}
                        filter showFilterOperator={false} showAddButton={false} filterPlaceholder="Escreva o filtro" filterField="dataPartida"
                        filterElement={dateRangeFilterTemplate} showFilterMenuOptions={false} filterApply={filterApplyTemplate} filterMenuStyle={{ zIndex: 50 }}
                    />
                    <Column field="dataRetorno" header="Dt. Retorno" body={(rowData: Viagem) => converterData(rowData.dataRetorno)}
                        filter showFilterOperator={false} showAddButton={false} filterPlaceholder="Escreva o filtro" filterField="dataRetorno"
                        filterElement={dateRangeFilterTemplate} showFilterMenuOptions={false} filterApply={filterApplyTemplate} filterMenuStyle={{ zIndex: 50 }}
                    />
                    <Column
                        field="valorAdiantamento" header="Adiantamento" body={(rowData: Viagem) => rowData.valorAdiantamento.toLocaleString('pt-BR', { style: 'currency', currency: 'BRL' })}
                        filter showFilterOperator={false} showAddButton={false} filterPlaceholder="Escreva o filtro"
                        filterMatchModeOptions={NumberMatchModeOptions} filterApply={filterApplyTemplate}
                    />
                    <Column key="colOpcoes" style={{ whiteSpace: 'nowrap', width: '7em' }}
                        body={(rowData: Viagem) => {
                            return (
                                <div>
                                    <Button type="button" icon={<FontAwesomeIcon icon="edit" />} className="ui-button-info" onClick={() => navigate(`/viagem/editar/${rowData.id}`)}></Button>
                                    <Button type="button" icon={<FontAwesomeIcon icon="remove" />} className="ui-button-danger" style={{ marginLeft: 8 }} onClick={() => remover(rowData.id)}></Button>
                                </div>
                            )
                        }} />
                </DataTable>
            </Base>
        </>
    )
}